import { useCallback, useState } from "react";

export function useMenuState() {
  const [isOpenMenu, setIsOpenMenu] = useState(true);
  const [isHover, setIsHover] = useState(true);

  const toggleMenuHandler = useCallback(() => {
    setIsOpenMenu((state) => !state);
    setIsHover(false);
  }, [setIsOpenMenu]);
  const onMouseLeave = useCallback(() => {
    if (window.innerWidth > 830) {
      // md util width
      setIsHover(false);
    }
  }, [setIsHover]);
  const onMouseEnter = useCallback(() => {
    if (window.innerWidth > 830) {
      // md util width
      setIsHover(true);
    }
  }, [setIsHover]);

  return {
    toggleMenuHandler,
    onMouseEnter,
    onMouseLeave,
    isHover,
    showNavigation: isOpenMenu ? isOpenMenu : isHover,
  };
}
